import { FeatureService } from './../core/services/feature/feature.service';
import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import {
  ReplaceableComponentsService,
  EnvironmentService,
  ConfigStateService,
  LocalizationService,
  PermissionService,
} from '@abp/ng.core';
import {
  eSettingManamagementSettingTabNames,
  SettingTabsService,
} from '@abp/ng.setting-management/config';
import { EmailSettingGroupComponent as CAEmailSettingGroupComponent } from './replacement/settings/email-setting-group/email-setting-group.component';
import { AnalyticsSettingGroupComponent } from './administration/settings/analytics-setting-group/analytics-setting-group.component';
import { AutomaticQualityManagementSettingGroupComponent } from './administration/settings/automatic-quality-management-setting-group/automatic-quality-management-setting-group.component';
import { RecorderManagementSettingGroupComponent } from './administration/settings/recorder-management-setting-group/recorder-management-setting-group.component';
import { PermissionConstants } from 'src/core/constants/permission-constant';
import { PrivacySettingGroupComponent } from './administration/settings/privacy-setting-group/privacy-setting-group.component';
import { OtherSettingGroupComponent } from './administration/settings/other-setting-group/other-setting-group.component';
import { UserMainComponent } from './replacement/user/user-main/user-main.component';
import { eThemeLeptonComponents } from '@volo/abp.ng.theme.lepton';
import { IndexingSettingsComponent } from './administration/settings/indexing-settings/indexing-settings.component';
import { Select, Store, UpdateState } from '@ngxs/store';
import { CanDeactivateState } from 'src/core/guards/can-deactivate.guard';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, take, tap } from 'rxjs/operators';
import { OAuthService } from 'angular-oauth2-oidc';
import { NavMenuItemService } from 'src/core/services/nav-menu/nav-menu-item.service';
import { CorporateIdentitySettingsService } from 'src/core/services/settings/corporate-identity-settings.service';
import { TimeZoneHelper } from 'src/core/services/helper/timezone-helper';
import { ObjectHelper } from 'src/core/helpers/object.helper';
import { FooterComponent } from './footer/footer/footer.component';
import { NotificationService } from 'src/core/services/notification/notification.service';
import { FeatureConstants } from 'src/core/constants/feature-constant';
import { ScopeService } from 'src/core/services/administration/scope.service';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { NgbConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { eUserMenuItems } from '@abp/ng.theme.basic';
import { NavItemsService, UserMenuService } from '@abp/ng.theme.shared';
import { NotificationIconComponent } from 'src/ca-shared/nav-items/notification-icon/notification-icon.component';
import { ResetUserSettingsComponent } from 'src/ca-shared/nav-items/reset-user-settings/reset-user-settings.component';
import { AboutComponent } from 'src/ca-shared/nav-items/about/about.component';
import { CA_NAVIGATE_TO_MANAGE_PROFILE } from 'src/core/constants/ca-manage-profile.token';
import { CA_NAVIGATE_TO_SECURITY_LOGS } from 'src/core/constants/ca-security-logs.token';
import { LanguagesComponent } from 'src/ca-shared/nav-items/languages/languages.component';
import {
  PremiumReportingAddMenuService,
  PremiumReportingConfigService,
  PremiumReportingMenuService,
} from '@sestek/premium-reporting/config';
import { VideoPlayerIconComponent } from 'src/ca-shared/nav-items/video-player-icon/video-player-icon.component';
import { NotificationState } from 'src/core/states/notification/notification.state';
import { Observable } from 'rxjs';
import { NotificationCountSummaryDto } from 'src/core/models/notification/notification-count-summary.dto';
import { ClearCacheComponent } from 'src/ca-shared/nav-items/clear-cache/clear-cache.component';
import { ZendeskApplicationSettingsComponent } from './administration/settings/integration-settings/zendesk-application-settings/zendesk-application-settings.component';
import { ZoomMeetingApplicationSettingsComponent } from './administration/settings/integration-settings/zoom-meeting-application-settings/zoom-meeting-application-settings.component';
import { ZoomContactCenterApplicationSettingsComponent } from './administration/settings/integration-settings/zoom-contactcenter-application-settings/zoom-contactcenter-application-settings.component';
import { MatIconRegistry } from '@angular/material/icon';
import { SettingService } from 'src/core/services/settings/setting.service';
import { IntegrationSettingsComponent } from './administration/settings/integration-settings/integration-settings.component';
import { UserLoginDateChange } from 'src/core/actions/administration/user-login.action';
import { RealTimeSettingGroupComponent } from './administration/settings/real-time-setting-group/real-time-setting-group.component';
import { GenerativeAiSettingGroupComponent } from './administration/settings/generative-ai-setting-group/generative-ai-setting-group.component';
import { FeatureManagementTabComponent } from '@abp/ng.feature-management';
import { RequiredMultiplePoliciesGuard } from 'src/core/guards/required-multiple-policies.guard';
import { AIDisclaimerModalComponent } from './ai-disclaimer/ai-disclaimer-modal.component';
import { UserService } from 'src/core/services/administration/user.service';
import { eAccountSettingTabNames } from '@volo/abp.ng.account/admin/config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, AfterViewInit {
  titleDictionary = new Map<string, string>([
    ['languages', 'LanguageManagement::Languages'],
    ['texts', 'LanguageManagement::LanguageTexts'],
    ['organization-units', 'AbpIdentity::OrganizationUnits'],
    ['roles', 'AbpIdentity::Roles'],
    ['users', 'AbpIdentity::Users'],
    ['identity/user-groups', 'UserGroup::Menu:UserGroups'],
    ['security-logs', 'AbpIdentity::SecurityLogs'],
    ['list', 'PremiumReporting::Menu:PremiumReportsList'],
    ['view', 'PremiumReporting::Menu:PremiumReportsView'],
    ['tenants', 'Saas::Tenants'],
    ['editions', 'Saas::Editions'],
  ]);
  private currentTitle: string;
  private notificationTitleInterval: any;
  private notificationCount: number = 0;
  private notificationTitleState: boolean = true;
  idParam: number = null;
  private modalShown = false;

  @Select(NotificationState.getCountSummary)
  notificationCountSummary$: Observable<NotificationCountSummaryDto>;

  constructor(
    private settingTabs: SettingTabsService,
    private replaceableComponentsService: ReplaceableComponentsService,
    private configStateService: ConfigStateService,
    private store: Store,
    private featureService: FeatureService,
    private settingService: SettingService,
    private scopeService: ScopeService,
    readonly router: Router,
    private oAuthService: OAuthService,
    private menuItemService: NavMenuItemService,
    readonly timeZoneHelper: TimeZoneHelper,
    private corporateIdentitySettingsService: CorporateIdentitySettingsService,
    private environment: EnvironmentService,
    private notificationService: NotificationService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private localizationService: LocalizationService,
    private ngbConfig: NgbConfig,
    private navItemsService: NavItemsService,
    private userMenuService: UserMenuService,
    private injector: Injector,
    private premiumReportingConfigService: PremiumReportingConfigService,
    private premiumReportingMenuService: PremiumReportingMenuService,
    private premiumReportingAddMenuService: PremiumReportingAddMenuService,
    private permissionService: PermissionService,
    private matIconRegistry: MatIconRegistry,
    private requiredMultiplePoliciesGuard: RequiredMultiplePoliciesGuard,
    private domSanitizer: DomSanitizer,
    private modalService: NgbModal,
    private userService: UserService,
  ) {
    const navigateToManageProfile = this.injector.get(CA_NAVIGATE_TO_MANAGE_PROFILE);
    const navigateToSecurityLogs = this.injector.get(CA_NAVIGATE_TO_SECURITY_LOGS);

    this.configStateService.getDeep$('currentUser.id').subscribe(user => {
      if (user != null) {
        const actions = new UpdateState();
        this.store.dispatch(actions);
      }
    });

    let tenantId = this.configStateService.getDeep(['currentUser', 'tenantId']);
    let isHost = tenantId == null;

    this.ngbConfig.animation = false;

    this.applyCorporateIdentitySettings();
    this.registerCustomIcons();

    this.oAuthService.events.pipe(filter(event => event?.type === 'logout')).subscribe(event => {
      CanDeactivateState.hasLogoutBeenInitiated = true;
    });

    this.featureService.checkRoutesForFeatures();
    this.requiredMultiplePoliciesGuard.checkRoutesForMultiplePolicies();
    this.settingService.checkRoutesForSettings();
    this.scopeService.checkRoutesForScopes();

    // if the user clicks the back button, ask the CanDeactivateGuard to defend against this.
    window.onpopstate = () => (CanDeactivateState.defendAgainstBrowserBackButton = true);

    // Upon successful navigation, ensure that the CanDeactivateGuard no longer defends against back button clicks
    router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        tap(() => (CanDeactivateState.defendAgainstBrowserBackButton = false)),
      )
      .subscribe(e => {
        const navigation = this.router.getCurrentNavigation();

        if (navigation.extras.state && navigation.extras.state.settings) {
          const tabId = navigation.extras.queryParams.tabId;

          setTimeout(() => {
            const tab = document.getElementById(tabId);

            if (tab) {
              tab.click();
            }
          }, 500);
        }
      });

    Date.prototype.toJSON = function () {
      var copiedDate = new Date(this.getTime());
      const minutesDiff =
        this.getMinutes() -
        (timeZoneHelper.GetSystemTimeZoneOffsetInMinutes() + this.getTimezoneOffset());
      copiedDate.setMinutes(minutesDiff);
      var result = copiedDate.toISOString();
      return result;
    };

    this.notificationService.notificationReceived.subscribe(() => {
      this.notificationCountSummary$.pipe(take(1)).subscribe(n => {
        if (document.hidden) {
          this.notificationCount += 1;
          this.startNotificationTitleTimer();
        }
      });
    });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        this.stopNotificationTitleTimer();
      }
    });

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          this.idParam = null;

          while (child) {
            if (child.snapshot.params?.id > 0) {
              this.idParam = child.snapshot.params.id;
            }

            if (child.firstChild) {
              child = child.firstChild;
            } else if (child.snapshot.data && child.snapshot.data['title']) {
              return child.snapshot.data['title'];
            } else {
              if (this.titleDictionary.has(child.snapshot.routeConfig.path)) {
                return this.titleDictionary.get(child.snapshot.routeConfig.path);
              }
              return null;
            }
          }
          return null;
        }),
      )
      .subscribe((data: any) => {
        if (data) {
          let title = this.localizationService.instant(data);
          this.currentTitle = title;

          if (this.idParam > 0) {
            this.currentTitle = this.idParam + ' - ' + title;
          }

          this.titleService.setTitle(this.currentTitle);
        }
      });

    this.navItemsService.addItems([
      {
        id: 'VideoPlayerIcon',
        order: 1,
        component: VideoPlayerIconComponent,
      },
    ]);

    this.navItemsService.addItems([
      {
        id: 'NotificationIcon',
        order: 2,
        component: NotificationIconComponent,
      },
    ]);

    this.navItemsService.patchItem(eThemeLeptonComponents.Languages, {
      component: LanguagesComponent,
    });

    const userItems: any[] = [
      {
        id: 'ResetUserSettingsLink',
        order: 101,
        component: ResetUserSettingsComponent,
      },
      {
        id: 'AboutLink',
        order: 103,
        component: AboutComponent,
      },
    ];

    if (isHost) {
      userItems.push({
        id: 'ClearCacheLink',
        order: 102,
        component: ClearCacheComponent,
      });
    }

    this.userMenuService.addItems(userItems);

    this.userMenuService.patchItem(eUserMenuItems.Logout, {
      order: 104,
    });

    this.userMenuService.patchItem(eUserMenuItems.MyAccount, {
      action: () => navigateToManageProfile(),
    });

    this.userMenuService.patchItem('UserMenu.SecurityLogs', {
      action: () => navigateToSecurityLogs(),
    });

    this.userMenuService.removeItem('UserMenu.LinkedAccounts');
    var impersonateUserId = this.configStateService.getDeep('currentUser.impersonatorUserId');

    if (impersonateUserId) {
      this.userMenuService.removeItem(eUserMenuItems.MyAccount);
      this.userMenuService.removeItem('UserMenu.SecurityLogs');
    }

    this.settingTabs.patch(eSettingManamagementSettingTabNames.EmailSettingGroup, {
      name: eSettingManamagementSettingTabNames.EmailSettingGroup,
      component: CAEmailSettingGroupComponent,
    });

    this.initializeLogoutControl();

    this.checkAndShowDisclaimer();
  }

  private checkAndShowDisclaimer(): void {
    const isInitialSetupCompleted = this.configStateService.getSetting(
      'Global.IsInitialTenantSetupCompleted',
    );

    if (
      !this.oAuthService.hasValidAccessToken() ||
      this.modalShown ||
      isInitialSetupCompleted === 'False'
    ) {
      return;
    }

    this.userService.getConfirmedAiUsageDisclaimer().subscribe({
      next: confirmed => {
        if (!confirmed && !this.modalShown) {
          this.showAiDisclaimerModal();
        }
      },
      error: error => {
        console.error('AI Disclaimer check failed:', error);
      },
    });
  }

  private showAiDisclaimerModal(): void {
    this.modalShown = true;

    const modalRef = this.modalService.open(AIDisclaimerModalComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'ai-disclaimer-modal',
      centered: true,
    });

    modalRef.result.then(
      () => {
        this.modalShown = false;
      },
      () => {
        this.modalShown = false;
      },
    );
  }

  applyCorporateIdentitySettings() {
    this.corporateIdentitySettingsService.get().subscribe(result => {
      const logoFileBase64Uri = `data:${result.logoFileContentType};base64,${result.logoFileBytes}`;

      const environment = ObjectHelper.deepCopy(this.environment.getEnvironment());
      environment.application.name = result.title;
      environment.application.logoUrl = logoFileBase64Uri;
      this.environment.setState(environment);
      this.setLogo(logoFileBase64Uri);

      const faviconFileBase64Uri = `data:${result.faviconFileContentType};base64,${result.faviconFileBytes}`;
      this.setFavicon(faviconFileBase64Uri);
    });
  }

  setLogo(logoFileBase64Uri: string) {
    const logoUrl = `url("${logoFileBase64Uri}")`;
    document.documentElement.style.setProperty('--logo', logoUrl, 'important');
    document.documentElement.style.setProperty('--logo-reverse', logoUrl, 'important');
  }

  setFavicon(faviconFileBase64Uri: string) {
    const favIcon: HTMLLinkElement = document.querySelector('#appFavicon');
    favIcon.href = faviconFileBase64Uri;
  }

  ngOnInit() {
    this.checkInitialSetup();

    this.saveUserLoginState();

    this.replaceableComponentsService.add({
      component: UserMainComponent,
      key: 'Identity.UsersComponent',
    });

    this.replaceableComponentsService.add({
      component: FooterComponent,
      key: eThemeLeptonComponents.ApplicationLayoutFooter,
    });

    this.settingTabs.add([
      {
        name: 'Settings::Indexing',
        requiredPolicy: PermissionConstants.SettingManagement,
        component: IndexingSettingsComponent,
      },
      {
        name: 'Settings::ZoomMeetingApplication',
        requiredPolicy: PermissionConstants.SettingManagement,
        component: ZoomMeetingApplicationSettingsComponent,
      },
      {
        name: 'Settings::ZoomContactCenterApplication',
        requiredPolicy: PermissionConstants.SettingManagement,
        component: ZoomContactCenterApplicationSettingsComponent,
      },
      {
        name: 'Settings::ZendeskApplication',
        requiredPolicy: PermissionConstants.SettingManagement,
        component: ZendeskApplicationSettingsComponent,
      },
      {
        name: 'Settings::Analytics',
        component: AnalyticsSettingGroupComponent,
      },
      {
        name: 'Settings::RealTime',
        component: RealTimeSettingGroupComponent,
      },
      {
        name: 'Settings::AutomaticQualityManagement',
        component: AutomaticQualityManagementSettingGroupComponent,
      },
      {
        name: 'Settings::RecorderManagement',
        component: RecorderManagementSettingGroupComponent,
      },
      {
        name: 'Settings::OpenAiSettings',
        component: GenerativeAiSettingGroupComponent,
      },
      {
        name: 'Settings::Privacy',
        component: PrivacySettingGroupComponent,
      },
      {
        name: 'Settings::Other',
        component: OtherSettingGroupComponent,
      },
      {
        name: 'Settings::Integration',
        component: IntegrationSettingsComponent,
      },
      {
        name: 'AbpFeatureManagement::Menu:FeatureManagement',
        requiredPolicy: 'FeatureManagement.ManageHostFeatures',
        component: FeatureManagementTabComponent,
      },
    ]);

    if (this.settingTabs.find(x => x.name == 'AbpIdentity::Menu:IdentityManagement')) {
      this.settingTabs.patch('AbpIdentity::Menu:IdentityManagement', {
        name: 'AbpIdentity::Settings:IdentityManagement',
      });
    }

    this.settingTabs.remove(['LeptonThemeManagement::Menu:LeptonThemeSettings']);

    if (
      !(
        this.featureService.isEnabled(FeatureConstants.Analytics) &&
        this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement)
      ) &&
      !(
        this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement) ||
        this.permissionService.getGrantedPolicy(PermissionConstants.AttachedData) ||
        this.permissionService.getGrantedPolicy(PermissionConstants.IgnoredWords) ||
        this.permissionService.getGrantedPolicy(PermissionConstants.Sources) ||
        this.permissionService.getGrantedPolicy(PermissionConstants.TagAndAutoTagging) ||
        this.permissionService.getGrantedPolicy(PermissionConstants.PronunciationManagement)
      )
    ) {
      this.settingTabs.remove(['Settings::Analytics']);
    }

    if (
      !(
        this.featureService.isEnabled(FeatureConstants.RealTime) &&
        this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement)
      )
    ) {
      this.settingTabs.remove(['Settings::RealTime']);
    }

    if (
      !(
        this.featureService.isEnabled(FeatureConstants.QualityManagement) &&
        this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement)
      ) &&
      !(
        this.featureService.isEnabled(FeatureConstants.QualityManagement) &&
        this.permissionService.getGrantedPolicy(PermissionConstants.ReasonPool)
      )
    ) {
      this.settingTabs.remove(['Settings::AutomaticQualityManagement']);
    }

    if (
      !(
        this.featureService.isEnabled(FeatureConstants.CallRecorder) &&
        (this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement) ||
          this.permissionService.getGrantedPolicy(PermissionConstants.CallRecorderManagement))
      ) &&
      !(
        this.featureService.isEnabled(FeatureConstants.ScreenRecorder) &&
        (this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement) ||
          this.permissionService.getGrantedPolicy(PermissionConstants.ScreenRecorderManagement))
      )
    ) {
      this.settingTabs.remove(['Settings::RecorderManagement']);
    }

    if (
      !(
        this.featureService.isEnabled(FeatureConstants.Analytics) &&
        this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement)
      ) &&
      !(
        this.featureService.isEnabled(FeatureConstants.Analytics) &&
        this.featureService.isEnabled(FeatureConstants.AskGenAi) &&
        this.permissionService.getGrantedPolicy(PermissionConstants.RootCause)
      )
    ) {
      this.settingTabs.remove(['Settings::OpenAiSettings']);
    }

    if (!this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement)) {
      this.settingTabs.remove(['Settings::Privacy']);
    }

    if (
      !(
        this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement) ||
        this.permissionService.getGrantedPolicy(PermissionConstants.Department) ||
        this.permissionService.getGrantedPolicy(PermissionConstants.GenericLookup)
      )
    ) {
      this.settingTabs.remove(['Settings::Other']);
    }

    if (!this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement)) {
      this.settingTabs.remove(['Settings::Integration']);
    }

    if (!this.isHostUser()) {
      this.settingTabs.remove(['Settings::Indexing']);
      this.settingTabs.remove(['Settings::ZoomMeetingApplication']);
      this.settingTabs.remove(['Settings::ZoomContactCenterApplication']);
      this.settingTabs.remove(['Settings::ZendeskApplication']);
    }

    if (this.isHostUser()) {
      this.settingTabs.remove(['Settings::Integration']);
    } else if (!this.checkIntegration()) {
      this.settingTabs.remove(['Settings::Integration']);
    }

    this.settingTabs.remove(['PremiumReporting::Menu:PremiumReports']);

    if (
      this.permissionService.getGrantedPolicy(PermissionConstants.PremiumReports) &&
      this.featureService.isEnabled(FeatureConstants.PremiumReporting)
    ) {
      this.getPremiumReportingMenuList();
      this.premiumReportingMenuService.premiumReportingMenuChange.subscribe(() =>
        this.getPremiumReportingMenuList(),
      );
    }

    this.settingTabs.remove([eAccountSettingTabNames.TimeZone]);

    this.menuItemService.overrideNavMenuItemIcons();
  }

  getPremiumReportingMenuList() {
    this.premiumReportingConfigService.get({ maxResultCount: 50 }).subscribe(res => {
      const itemsWithLiteralNames = res.items.map(item => ({
        ...item,
        name: `::${item.name}`,
      }));

      this.premiumReportingAddMenuService.addMenu(itemsWithLiteralNames);
      this.menuItemService.overridePremiumReportsNavMenuItemIcons();
    });
  }

  isHostUser(): boolean {
    let tenantId = this.configStateService.getDeep(['currentUser', 'tenantId']);
    return tenantId == null;
  }

  checkInitialSetup() {
    const tenantId = this.configStateService.getDeep('currentUser.tenantId');

    const isInitialSetupCompleted = this.configStateService.getSetting(
      'Global.IsInitialTenantSetupCompleted',
    );

    if (
      this.oAuthService.hasValidAccessToken() &&
      tenantId &&
      isInitialSetupCompleted === 'False'
    ) {
      this.router.navigate(['/initial-setup']);
    }
  }

  saveUserLoginState() {
    if (this.oAuthService.hasValidAccessToken()) {
      this.saveState();
    }
  }

  saveState() {
    const date = new Date();
    const userLoginAction = new UserLoginDateChange(date);
    this.store.dispatch(userLoginAction);
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  private loadCrazyEgg() {
    let node = document.createElement('script');
    node.src = '//script.crazyegg.com/pages/scripts/0120/5459.js';
    node.type = 'text/javascript';
    node.async = true;
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  private startNotificationTitleTimer() {
    clearInterval(this.notificationTitleInterval);
    this.toggleNotificationTitle();
    this.notificationTitleInterval = setInterval(() => this.toggleNotificationTitle(), 3000);
  }

  private stopNotificationTitleTimer() {
    clearInterval(this.notificationTitleInterval);
    this.notificationTitleState = true;
    this.notificationCount = 0;
    this.titleService.setTitle(this.currentTitle);
  }

  private toggleNotificationTitle() {
    if (this.notificationTitleState) {
      this.titleService.setTitle(
        this.localizationService.instant('::TitleNotification', this.notificationCount.toString()),
      );
    } else {
      this.titleService.setTitle(this.currentTitle);
    }

    this.notificationTitleState = !this.notificationTitleState;
  }

  private initializeLogoutControl() {
    this.oAuthService.events.subscribe(event => {
      if (event.type === 'logout' && this.oAuthService['persistRedirectUri'] === undefined) {
        this.oAuthService.redirectUri = window.location.origin;
      }
    });
  }

  private registerCustomIcons(): void {
    this.matIconRegistry.addSvgIcon(
      'open-ai',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/icons/open-ai.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'ai-insights',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/icons/ai-insights.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'positive-feedback',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/images/icons/positive-feedback.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'negative-feedback',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/images/icons/negative-feedback.svg',
      ),
    );
  }

  private checkIntegration() {
    let amazonIntegration = this.featureService.isEnabled(FeatureConstants.AmazonIntegration);
    let amazonIntegrationOutOfMarketplace = this.featureService.isEnabled(
      FeatureConstants.AmazonIntegrationOutOfMarketplace,
    );
    let aloTechIntegration = this.featureService.isEnabled(FeatureConstants.AloTechIntegration);
    let aloTechV3Integration = this.featureService.isEnabled(FeatureConstants.AloTechV3Integration);
    let puzzelIntegration = this.featureService.isEnabled(FeatureConstants.PuzzelIntegration);
    let GenesysIntegration = this.featureService.isEnabled(FeatureConstants.GenesysIntegration);
    let GenesysGirIntegration = this.featureService.isEnabled(
      FeatureConstants.GenesysGIRIntegration,
    );
    let GenesysIntegrationOutOfMarketplace = this.featureService.isEnabled(
      FeatureConstants.GenesysIntegrationOutOfMarketplace,
    );
    let ZendeskIntegration = this.featureService.isEnabled(FeatureConstants.ZendeskIntegration);
    let ZoomMeetingIntegration = this.featureService.isEnabled(
      FeatureConstants.ZoomMeetingIntegration,
    );
    let ZoomContactCenterIntegration = this.featureService.isEnabled(
      FeatureConstants.ZoomContactCenterIntegration,
    );

    let twilioIntegration = this.featureService.isEnabled(FeatureConstants.TwilioIntegration);

    let dynamicsIntegration = this.featureService.isEnabled(FeatureConstants.DynamicsIntegration);

    let niceIntegration = this.featureService.isEnabled(FeatureConstants.NiceIntegration);

    return (
      amazonIntegration ||
      amazonIntegrationOutOfMarketplace ||
      aloTechIntegration ||
      aloTechV3Integration ||
      puzzelIntegration ||
      GenesysIntegration ||
      GenesysIntegrationOutOfMarketplace ||
      GenesysGirIntegration ||
      ZendeskIntegration ||
      ZoomContactCenterIntegration ||
      ZoomMeetingIntegration ||
      twilioIntegration ||
      dynamicsIntegration ||
      niceIntegration
    );
  }
}
